module.exports = __webpack_public_path__ + "img/logo_white.47d36728.png";